var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 750,
    viewBox: "0 0 1440 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__a",
    width: "104.4%",
    height: "112%",
    x: "-2.2%",
    y: "-6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__b",
    width: "112%",
    height: "112%",
    x: "-6%",
    y: "-6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__c",
    width: "111.8%",
    height: "104.3%",
    x: "-5.9%",
    y: "-2.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__d",
    width: "104.4%",
    height: "112%",
    x: "-2.2%",
    y: "-6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1444,
    height: 750,
    y: 210,
    fill: "#EBEFF2",
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E3E9ED"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.878 200.474h550.82V.391H.878z",
    filter: "url(#background_svg__a)",
    transform: "scale(1 -1) rotate(45 1918.939 238.747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.24 721.477c-39.113 39.113-102.485 39.147-141.556.076-39.071-39.071-39.037-102.444.076-141.557 39.105-39.105 102.485-39.146 141.556-.075 39.07 39.07 39.03 102.45-.076 141.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.494 458.787c0 55.255 44.835 100.042 100.15 100.042 55.303 0 100.148-44.787 100.148-100.042 0-55.254-44.845-100.041-100.149-100.041-55.314 0-100.149 44.787-100.149 100.041",
    filter: "url(#background_svg__b)",
    transform: "scale(1 -1) rotate(45 1918.939 238.747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.089 714.796c-39.071-39.07-39.03-102.45.076-141.556 39.113-39.113 102.485-39.147 141.556-.076 39.07 39.071 39.037 102.444-.076 141.557-39.105 39.105-102.485 39.146-141.556.075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.273 918.681H204.57V358.8H1.273z",
    filter: "url(#background_svg__c)",
    transform: "scale(1 -1) rotate(45 1918.939 238.747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.368 918.425h550.82V718.34h-550.82z",
    filter: "url(#background_svg__d)",
    transform: "scale(1 -1) rotate(45 1918.939 238.747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b04f6d943e57b1263adb3948518d199c.svg";
export { ForwardRef as ReactComponent };